var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.90723 0L11.0928 0C11.273 0.000765196 11.4489 0.0556288 11.5983 0.157654C11.7477 0.259678 11.8638 0.404283 11.9321 0.573181C12.0004 0.742079 12.0176 0.927686 11.9818 1.10653C11.9459 1.28538 11.8584 1.44943 11.7305 1.57795L6.64685 6.72705C6.56215 6.81354 6.46139 6.88218 6.35037 6.92903C6.23935 6.97588 6.12027 7 6 7C5.87973 7 5.76065 6.97588 5.64963 6.92903C5.53861 6.88218 5.43785 6.81354 5.35315 6.72705L0.269496 1.57795C0.141564 1.44943 0.05413 1.28538 0.0182482 1.10653C-0.0176337 0.927686 -0.000351774 0.742079 0.0679092 0.573181C0.13617 0.404283 0.252344 0.259678 0.401742 0.157654C0.551139 0.0556288 0.72705 0.000765196 0.90723 0Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDown);
export default __webpack_public_path__ + "static/media/VectorDown.0b77727f72c0f619d16c3e5369dda697.svg";
export { ForwardRef as ReactComponent };